import { jsx } from 'react/jsx-runtime';
import { ChatBubbleContent } from './ChatBubble.Content/ChatBubble.Content.es.js';
import { ChatBubbleProvider } from './ChatBubble.Context/provider.es.js';
import { ChatBubbleFooter } from './ChatBubble.Footer/ChatBubble.Footer.es.js';
import { ChatBubbleHeader } from './ChatBubble.Header/ChatBubble.Header.es.js';

const ChatBubble = ({ children, author })=>{
    return jsx(ChatBubbleProvider, {
        author: author,
        children: jsx("div", {
            className: "cb-chat-bubble",
            tabIndex: 0,
            children: children
        })
    });
};
ChatBubble.displayName = 'ChatBubble';
ChatBubble.Header = ChatBubbleHeader;
ChatBubble.Content = ChatBubbleContent;
ChatBubble.Footer = ChatBubbleFooter;

export { ChatBubble, ChatBubble as default };
//# sourceMappingURL=ChatBubble.es.js.map
